// Preset label colors for swatch pickers (tags, time tracking categories).
export const COLOR_PRESETS = [
  '#1d8cf8', '#e14eca', '#2dce89', '#fb6340',
  '#f5365c', '#ffd600', '#11cdef', '#8965e0',
  '#525f7f', '#d44872',
]
